import { useWalletAddress } from '@/features/account-abstraction/hooks/useWalletAddress';
import useWalletBalance from '@/hooks/useWalletBalance';
import config from '@/common/config';
import LoadingSpinner from '@/components/LoadingSpinner/LoadingSpinner';
import { useQuery } from '@tanstack/react-query';
import { getTotalUnpaidRakeback } from '@/services/rake/rake.service';
import usdt from '@/assets/profile/tether.svg';
import React, { useMemo, useState } from 'react';
import usePhnmPrice from '@/hooks/usePhnmPrice';
import PHNMTokenIcon from '@/components/PHNMTokenIcon';
import RewardsModal from '@/features/rewards/RewardsModal';
import useRakeBackAmount from '@/hooks/useRakeBackAmount';

// TODO all information is mocked, will be replaced once real token is implemented
function PhenomBalance() {
  const { walletAddress, isLoading: isLoadingWallet } = useWalletAddress();
  const [showRewardsModal, setShowRewardsModal] = useState(false);

  const { data: phnmBalance, isLoading } = useWalletBalance(walletAddress, config.contracts.phnm);

  const { data: phnmPrice, isLoading: isLoadingPhnmPrice } = usePhnmPrice();

  const { rakebackAmount, isLoadingRakeBack } = useRakeBackAmount();

  const phnmDisplayPrice = useMemo(() => {
    const amount = phnmPrice?.displayPrice || 0;
    return Number(amount).toFixed(2);
  }, [phnmPrice?.displayPrice]);

  const handleShowRewards = () => setShowRewardsModal(true);

  return (
    <>
      <div className="w-full rounded-3xl bg-phenom-background-gradient-gray-violet-dark p-[1px]">
        <div className="flex h-full w-full flex-col items-center justify-between gap-3 overflow-hidden rounded-3xl bg-ph-violet-dark align-middle">
          <div className="flex h-9 w-full items-center justify-center gap-2 bg-ph-primary-violet bg-opacity-25 align-middle">
            <PHNMTokenIcon className="h-4 w-4" />
            <p className="font-manrope text-xs font-semibold text-ph-gray-white">1.00 PHNM</p>
            <p className="font-manrope text-xs font-semibold text-ph-gray-white">=</p>
            <img src={usdt} alt="phenom token" className="h-4 w-4" />
            <p className="font-manrope text-xs font-semibold text-ph-gray-white">
              {isLoadingPhnmPrice ? <LoadingSpinner size="4" /> : `${phnmDisplayPrice}`}
            </p>
          </div>

          <div className="flex w-full flex-col px-4 pb-4">
            <div className="mb-4 grid w-full grid-cols-3 items-center">
              <div className="flex flex-col items-center gap-1">
                <span className="font-manrope text-sm font-bold text-ph-gray-evening">Pending</span>

                <div className="flex w-full items-center justify-center gap-2">
                  <img src={usdt} alt="usdt" className="h-[22px] w-[22px]" />
                  <p className="font-manrope text-xl font-semibold text-ph-gray-white">
                    {isLoadingRakeBack ? <LoadingSpinner size="4" /> : `${rakebackAmount}`}
                  </p>
                </div>
              </div>

              <div className="mx-auto h-12 w-px self-stretch bg-ph-gray-evening"></div>

              <div className="flex flex-col items-center gap-1">
                <span className="font-manrope text-sm font-bold text-ph-gray-evening">Available</span>

                <div className="flex w-full items-center justify-end justify-center gap-2">
                  <PHNMTokenIcon className="h-6 w-6" />
                  {isLoading || isLoadingWallet ? (
                    <LoadingSpinner size="4" />
                  ) : (
                    <p className="font-manrope text-xl font-semibold text-ph-gray-white">
                      {phnmBalance.displayBalance}
                    </p>
                  )}
                </div>
              </div>
            </div>
            <span
              className="flex w-full cursor-pointer justify-center font-manrope text-xs font-bold text-ph-primary-violet"
              onClick={handleShowRewards}
            >
              Manage Rewards
            </span>
          </div>
        </div>
      </div>
      <RewardsModal open={showRewardsModal} setClose={() => setShowRewardsModal(false)} />
    </>
  );
}

export default PhenomBalance;
